import { Stack } from "@mantine/core";
import { PageHeader } from "components";
import PageContent from "components/layouts/PageContent";
import { FC } from "react";
import { useTableParams } from "utils/hooks/common/useTableParams";
import RegionTable from "./components/RegionTable/RegionTable";
import RegionActions from "./components/RegionActions/RegionActions";

const REGION_PAGE_TITLE = "Quản lý Địa bàn";

const RegionWebLayout: FC = () => {
  const { params, handlePageChange, handleLimitChange, handleSearch } =
    useTableParams();

  return (
    <Stack gap="sm">
      <PageHeader breadcrumbs={[{ title: REGION_PAGE_TITLE, href: "" }]} />
      <PageContent>
        <Stack gap="xs">
          <RegionActions handleSearch={handleSearch} params={params} />
          <RegionTable
            params={params}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
          />
        </Stack>
      </PageContent>
    </Stack>
  );
};

export default RegionWebLayout;
